import { formatNumberFixed, formatUsdCompact, formatZec } from "@/lib/cypherpunk/format";
import type { CypherpunkTrackerPayload } from "@/types/cypherpunkTrackerData";
import { CYPH_PROGRESS_HERO, CYPH_PROGRESS_MARKERS } from "@/constants/cypherpunkTracker";

export default function FivePercentProgress({
  data,
}: {
  data: CypherpunkTrackerPayload;
}): React.ReactElement {
  const progressPct = formatNumberFixed(data.goal.progressToGoalPct);

  return (
    <div className="card cyph-defer-paint">
      <div className="card-head">
        <div>
          <div className="card-title">{CYPH_PROGRESS_HERO.title}</div>
          <div className="card-sub">{CYPH_PROGRESS_HERO.subtitle}</div>
        </div>
      </div>

      <div className="progress-display">
        <div className="progress-headline text-accent-gold">
          <span className="cyph-num">{progressPct}</span>%
        </div>
        <div className="progress-headline-sub">
          of the way to the 5% network ownership goal
        </div>

        <div className="progress-bar-wrap">
          <div className="progress-labels">
            <span>
              <span className="cyph-num">0</span>%
            </span>
            <span>
              <span className="cyph-num">5</span>% GOAL
            </span>
          </div>
          <div
            className="progress-bar"
            style={
              {
                "--progress-width": `${Math.min(100, data.goal.progressToGoalPct)}%`,
              } as React.CSSProperties
            }
          >
            <div className="progress-bar-fill" />
            {CYPH_PROGRESS_MARKERS.map((marker) => (
              <div key={marker.label} className="progress-marker" style={{ left: marker.left }}>
                <span className="marker-label">{marker.label}</span>
              </div>
            ))}
            <div className="progress-marker now">
              <span className="marker-label">NOW</span>
            </div>
          </div>
        </div>
      </div>

      <div className="stat-grid">
        <div className="stat">
          <div className="stat-label">ZEC still needed</div>
          <div className="stat-value">
            <span className="cyph-num">{formatZec(data.goal.zecStillNeeded)}</span>
          </div>
          <div className="stat-delta">to hit 5%</div>
        </div>

        <div className="stat">
          <div className="stat-label">Projected ETA at current pace</div>
          <div className="stat-value">{data.goal.projectedEta ?? "—"}</div>
          <div className="stat-delta">linear extrapolation</div>
        </div>

        <div className="stat">
          <div className="stat-label">$ to hit goal (at spot)</div>
          <div className="stat-value">
            <span className="cyph-num">{formatUsdCompact(data.goal.usdToHitGoalAtSpot)}</span>
          </div>
          <div className="stat-delta">at current ZEC price</div>
        </div>
      </div>
    </div>
  );
}
